import { NoOpsSelected, PageError, PageLoading } from '../../../../components';
import {
  PagamentoHeader,
  PagamentoSummaryCards,
  PagamentoTable,
} from './components';
import { useIndrivePagamento } from './hooks/use-indrive-pagamento';

export function IndrivePagamento() {
  const {
    currentOps,
    data,
    loading,
    isFetching,
    error,
    selectedDate,
    columns,
    formatCurrency,
    handleDateChange,
    loadData,
  } = useIndrivePagamento();

  if (!currentOps) {
    return (
      <NoOpsSelected message="Selecione uma operação para visualizar os pagamentos." />
    );
  }

  return (
    <div className="space-y-6">
      <PagamentoHeader
        selectedDate={selectedDate}
        onDateChange={handleDateChange}
        onRefresh={loadData}
        isRefreshing={isFetching}
      />

      <PageError error={error} />

      <PageLoading loading={loading} />

      {!loading && data && (
        <>
          <PagamentoSummaryCards
            summary={data.summary}
            formatCurrency={formatCurrency}
          />
          <PagamentoTable data={data.antecipacoes ?? []} columns={columns} />
        </>
      )}
    </div>
  );
}
